import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  AppLayout,
  SideNavigation,
  TopNavigation,
  Button,
  SpaceBetween
} from '@cloudscape-design/components'
import { Logo } from './Logo'
import { Footer } from './Footer'
import { NavigationMenu } from './NavigationMenu'
import logoSvg from '../assets/logo.svg'

interface User {
  username: string
  email?: string
  name?: string
}

interface AuthenticatedLayoutProps {
  children: React.ReactNode
  user: User
  signOut: () => void
}

export const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({
  children,
  user,
  signOut
}) => {
  const location = useLocation()
  const [navigationOpen, setNavigationOpen] = React.useState(true)

  return (
    <AppLayout
      headerSelector="#top-nav"
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      navigation={<NavigationMenu />}
      content={
        <>
          {children}
          <Footer />
        </>
      }
      toolsHide={true}
    />
  )
}

// Top Navigation Component (deprecated - use TopNavBar.tsx instead)
export const TopNav: React.FC<{ user: User; signOut: () => void }> = ({ user, signOut }) => {
  return (
    <div id="top-nav">
      <TopNavigation
        identity={{
          href: '/',
          title: 'Live Maps'
        }}
        utilities={[
          {
            type: 'menu-dropdown',
            text: user.email || 'User',
            description: user.email,
            items: [
              {
                id: 'signout',
                text: 'Sign out'
              }
            ],
            onItemClick: ({ detail }) => {
              if (detail.id === 'signout') {
                signOut()
              }
            }
          }
        ]}
      />
    </div>
  )
}